import { render } from "./BottomStickyBanner.vue?vue&type=template&id=4acb5c32"
import script from "./BottomStickyBanner.vue?vue&type=script&lang=js"
export * from "./BottomStickyBanner.vue?vue&type=script&lang=js"

import "./BottomStickyBanner.vue?vue&type=style&index=0&id=4acb5c32&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__